module.exports = require("core-js-pure/features/object/define-property");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js/object/define-property.js
// module id = 151
// module chunks = 0 1